import { useEffect } from 'react';
import styled from 'styled-components';
import Colors from '../../ui/global/Colors';
import VideoPlayer from './VideoPlayer';
import Button from '../../ui/components/Button';
import { useNavigate, Link } from 'react-router-dom';
import { defaultConfig } from '../../utils/config';
import { navigateToWebsite } from '../../utils/urls';

const Root = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    height: 100svh;
    background-color: ${Colors.black};
    color: ${Colors.white};
    padding: 10px;
    margin: 0;
    overflow-x: hidden;
    overflow-y: auto;
`;

const ContentContainer = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 1200px;
    max-height: 100%;
    gap: 10px;
`;

const Watch = () => {
    const navigate = useNavigate();

    const demoVideoUrl = "https://cegqyfnwjaxjtssjnmda.supabase.co/storage/v1/object/public/playmix-assets/website/playmix_demo.mp4";
    const demoCaptionsUrl = "https://cegqyfnwjaxjtssjnmda.supabase.co/storage/v1/object/public/playmix-assets/website/playmix_demo_captions.vtt";
    const thumbnailUrl = "https://cegqyfnwjaxjtssjnmda.supabase.co/storage/v1/object/public/playmix-assets/website/playmix_demo_thumb.jpg";

    useEffect(() => {
        const script = document.createElement('script');
        script.type = 'application/ld+json';
        script.innerHTML = JSON.stringify({
            "@context": "https://schema.org",
            "@type": "VideoObject",
            "name": "playmix - vibe create games",
            "description": "Turn any idea into a playable game in seconds with playmix.ai.",
            "thumbnailUrl": [thumbnailUrl],
            "uploadDate": "2024-01-01T08:00:00+08:00",
            "contentUrl": demoVideoUrl,
            "embedUrl": window.location.href
        });
        document.head.appendChild(script);
        return () => {
            document.head.removeChild(script);
        };
    }, [demoVideoUrl, thumbnailUrl]);

    return (
        <Root>
            <ContentContainer>
                <VideoPlayer videoUrl={demoVideoUrl} captions={demoCaptionsUrl} />
                <Link to={'/'} style={{ textDecoration: 'none' }}>
                <Button
                    text="Back to playmix"
                    onClick={() => {
                        if (defaultConfig.REDIRECT_TO_WEBSITE) {
                            navigateToWebsite('/');
                        } else {
                            navigate('/');
                        }
                    }}
                    color='white'
                />
                </Link>
            </ContentContainer>
        </Root>
    )
};

export default Watch;